import type { MouseEventHandler } from 'react';
import type { GestureResponderEvent } from 'react-native';

import type { UIResolvedContentReference } from './types';

/**
 * Generate the props necesserary for a proper link to a given content ref
 */
export function getContentReferenceLinkProps(
    ref: UIResolvedContentReference,
    onPress?: (event?: GestureResponderEvent) => void
) {
    return {
        href: ref.href,
        onPress: (event?: GestureResponderEvent) => {
            if (onPress) {
                onPress(event);
            }

            if (event) {
                if (event.isDefaultPrevented()) {
                    return;
                }

                // if they want to open in a new tab, let them
                // @ts-ignore
                if (event.nativeEvent.metaKey || event.nativeEvent.ctrlKey) {
                    return;
                }

                event.preventDefault();
            }

            ref.open();
        },
    };
}

/**
 * Generate the props necesserary for a proper link to a given content ref.
 * Works with DOM elements.
 */
export function getContentReferenceLinkDomProps(
    ref: UIResolvedContentReference,
    props?: {
        onClick?: MouseEventHandler;
    }
): { href: string; onClick: MouseEventHandler } | null {
    if (!ref.href) {
        return null;
    }

    return {
        href: ref.href,
        onClick: (event) => {
            props?.onClick?.(event);

            if (event.isDefaultPrevented() || event.nativeEvent.altKey) {
                return;
            }

            event.preventDefault();
            ref.open();
        },
    };
}
